import * as React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  CardActions,
  IconButton,
  Dialog,
  Skeleton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import DeleteDialog from './DeleteDialog';

const useStyles = makeStyles(() => ({
  actions: {
    marginLeft: 'auto',
  },
}));

type Props = {
  loading: boolean;
  deleteLoading: boolean;
  ns: string;
  editing: boolean;
  deleting: boolean;
  editingContent: React.ReactNode;
  onEditClose: () => void;
  onDeleteConfirm: () => void;
  onDeleteClick: () => void;
  onDeleteClose: () => void;
  deleteEmail?: string;
};

const ListCardActions: React.FC<Props> = ({
  loading,
  deleteLoading,
  ns,
  editing,
  deleting,
  onDeleteClick,
  onDeleteClose,
  editingContent,
  onEditClose,
  onDeleteConfirm,
  deleteEmail,
}: Props) => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <CardActions>
      {loading ? (
        <Skeleton className={classes.actions}>
          <IconButton size="large">
            <DeleteIcon />
          </IconButton>
        </Skeleton>
      ) : (
        <IconButton
          className={classes.actions}
          title={t('common:delete')}
          color="secondary"
          onClick={onDeleteClick}
          size="large">
          <DeleteIcon />
        </IconButton>
      )}
      <Dialog open={editing} onClose={onEditClose}>
        {editingContent}
      </Dialog>
      <DeleteDialog
        open={deleting}
        onClose={onDeleteClose}
        onConfirm={onDeleteConfirm}
        loading={deleteLoading}
        ns={ns}
        email={deleteEmail}
      />
    </CardActions>
  );
};

export default ListCardActions;
